import React from "react";
import {
  SimpleForm,
  TextInput,
  DateInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  required,
  useTranslate,
} from "react-admin";
import * as Validation from "../utils/validation";
const url = () => (value) => {
  let valid = Validation.url(value);
  return valid !== true ? valid : undefined;
};

const Form = (props) => {
  const translate = useTranslate();
  return (
    <SimpleForm {...props} redirect="list">
      <ReferenceInput
        source="bookmaker_id"
        reference="bookmakers"
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" fullWidth validate={required()} />
      <TextInput source="url" fullWidth validate={[required(), url()]} />
      <DateInput source="start_at" validate={[required()]} />
      <DateInput source="end_at" />
      <BooleanInput
        source="is_default"
        helperText={translate(
          "resources.bookmaker-landings.fields.is_default.help"
        )}
      />
    </SimpleForm>
  );
};
export default Form;
